




































import Vue from "vue";
import userInfoProvider from "@/services/userInfoProvider";
import defaultDataProviderFactory from "@/services/identity-authen/defaultDataProvider";
const defaultDataProvider = defaultDataProviderFactory();

export default Vue.extend({
  props: ["tryLogout"],
  data() {
    return {
      logoutDialog: false,
    };
  },
  methods: {
    async logout() {
      const data = await defaultDataProvider.execute("Logout", {
        body: {},
      });
      userInfoProvider.deleteAccessToken();
      localStorage.clear()
      this.$router.push("/login/prepare");
      this.logoutDialog = false;
    },
  },
  created() {
    this.userInfo = userInfoProvider.getUserInfo();
  },
});
